import { render, staticRenderFns } from "./ResouceIframe.vue?vue&type=template&id=7545630a"
import script from "./ResouceIframe.vue?vue&type=script&lang=js"
export * from "./ResouceIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports